module.exports = __webpack_public_path__ + "static/media/1.cb4f8053.jpg";